import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card shadow-sm" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { ref: "chartCanvas" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card-header bg-success text-white" }, [
      _createElementVNode("i", { class: "fas fa-chart-pie me-2" }),
      _createTextVNode(" Répartition des utilisateurs par ville ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("canvas", _hoisted_3, null, 512)
    ])
  ]))
}